import { Injectable } from '@angular/core';
import { Usuario, Usuario2, Usuario3, UserOptions } from '../../models/usuario.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import Swal from 'sweetalert2';
import { map } from 'rxjs/operators';
import 'rxjs/add/operator/map';
import { Router } from '@angular/router';


@Injectable()
export class UsuarioService {

  usuario: Usuario;
  token: string;
  usuario2: Usuario2;
  idUsuario: string;
  options: any[] = [];
  constructor(
    public http: HttpClient,
    public router: Router
  ) {

  }

  estaLogueado() {
   // return ( this.token.length > 5 ) ? true : false;
   if ( localStorage.getItem('token') && localStorage.getItem('token').length > 5 ) {
   let stringExpiraToken = localStorage.getItem('expiratoken');
   stringExpiraToken = stringExpiraToken.substring(0, 10);


   const fechaExpiraToken = Date.parse(stringExpiraToken);
   const fechaHoy = new Date();
   const fechaHoyA = fechaHoy.getFullYear().toString();
   let fechaHoyM = (fechaHoy.getMonth() + 1).toString();
   let fechaHoyD = fechaHoy.getDate().toString();

   if ( fechaHoyM.length === 1 ) {
    fechaHoyM = ( '0' + fechaHoyM );
   }

   if ( fechaHoyD.length === 1 ) {
    fechaHoyD = ( '0' + fechaHoyD );
   }

   const fechaHoyC = Date.parse(fechaHoyA + '-' + fechaHoyM + '-' + fechaHoyD);

   

    if ( fechaExpiraToken > fechaHoyC ) {
      return true;
    } else {
      this.logoutsinboton();
      return false;
    }
  } else {
      this.logoutsinboton();
      return false;
  }
}

estaLogueador() {
  // return ( this.token.length > 5 ) ? true : false;
  if ( localStorage.getItem('token') && localStorage.getItem('token').length > 5 ) {
  let stringExpiraToken = localStorage.getItem('expiratoken');
  stringExpiraToken = stringExpiraToken.substring(0, 10);


  const fechaExpiraToken = Date.parse(stringExpiraToken);
  const fechaHoy = new Date();
  const fechaHoyA = fechaHoy.getFullYear().toString();
  let fechaHoyM = (fechaHoy.getMonth() + 1).toString();
  let fechaHoyD = fechaHoy.getDate().toString();

  if ( fechaHoyM.length === 1 ) {
   fechaHoyM = ( '0' + fechaHoyM );
  }

  if ( fechaHoyD.length === 1 ) {
   fechaHoyD = ( '0' + fechaHoyD );
  }

  const fechaHoyC = Date.parse(fechaHoyA + '-' + fechaHoyM + '-' + fechaHoyD);

  

   if ( fechaExpiraToken > fechaHoyC ) {
     return true;
   } else {
     this.logoutsinboton();
     return false;
   }
 } else {
     this.logoutsinboton();
     return false;
 }
}


  guardarStoragelogin( id: string, token: string, multi_supplier: any, usuario: Usuario, email: string, expiratoken: string, relations: any, job: string, foreign?: any ) {

    localStorage.setItem('id', id );
    localStorage.setItem('token', token );
    localStorage.setItem('multi_supplier', multi_supplier);
    localStorage.setItem('usuario', JSON.stringify(usuario) );
    localStorage.setItem('emailuser', email );
    localStorage.setItem('expiratoken', expiratoken);
    localStorage.setItem('user_options', JSON.stringify(relations));
    localStorage.setItem('quiensoy', 'factor');
    localStorage.setItem('job', JSON.stringify(job));
    localStorage.setItem('foreign', (foreign === true || foreign === 'true') ? 'true' : 'false');
    this.usuario = usuario;
    this.token = token;
  }

  logout() {

    Swal.fire({
      title: 'Cerrar Sesión?',
      text: `Se cerrará la sesión actual`,
      icon: 'question',
      showConfirmButton: true,
      showCancelButton: true,
    }). then ( resp => {
      if ( resp.value) {

        this.usuario = null;
        this.token = '';
        // Backend URL Switch — DESHABILITADO tras migración a fargate.
        // Fecha desactivación: 09/09/2026
        // Referencia: .kiro/specs/backend-url-switch
        // // Limpieza del override de backend URL. 08/07/2026
        // sessionStorage.removeItem('API_BASE_URL_OVERRIDE');
        localStorage.removeItem('token');
        localStorage.removeItem('usuario');
        localStorage.removeItem('id');
        localStorage.removeItem('emailuser');
        localStorage.removeItem('multi_supplier');
        localStorage.removeItem('expiratoken');
        localStorage.removeItem('usuarioPrivilegio');
        localStorage.removeItem('user_options');
        localStorage.removeItem('dataacc');
        localStorage.removeItem('quiensoy');
        localStorage.removeItem('job');
        localStorage.removeItem('foreign');
        this.router.navigate(['/login']);
        Swal.fire(
    'Terminó la sesión',
    'Correctamente',
    'info'
  );
      }
    });


  }

  logoutbase() {

    Swal.fire({
      title: 'Cerrar Sesión?',
      text: `Se cerrará la sesión actual`,
      icon: 'question',
      showConfirmButton: true,
      showCancelButton: true,
    }). then ( resp => {
      if ( resp.value) {

        this.usuario = null;
        this.token = '';
        // Backend URL Switch — DESHABILITADO tras migración a fargate.
        // Fecha desactivación: 09/09/2026
        // Referencia: .kiro/specs/backend-url-switch
        // // Limpieza del override de backend URL. 08/07/2026
        // sessionStorage.removeItem('API_BASE_URL_OVERRIDE');
        localStorage.removeItem('token');
        localStorage.removeItem('usuario');
        localStorage.removeItem('id');
        localStorage.removeItem('emailuser');
        localStorage.removeItem('multi_supplier');
        localStorage.removeItem('expiratoken');
        localStorage.removeItem('usuarioPrivilegio');
        localStorage.removeItem('user_options');
        localStorage.removeItem('dataacc');
        localStorage.removeItem('quiensoy');
        localStorage.removeItem('job');
        localStorage.removeItem('foreign');
        this.router.navigate(['/loginbase']);
        Swal.fire(
    'Terminó la sesión',
    'Correctamente',
    'info'
  );
      }
    });


  }

  logoutven() {

    Swal.fire({
      title: 'Cerrar Sesión?',
      text: `Se cerrará la sesión actual`,
      icon: 'question',
      showConfirmButton: true,
      showCancelButton: true,
    }). then ( resp => {
      if ( resp.value) {

        this.usuario = null;
        this.token = '';
        // Backend URL Switch — DESHABILITADO tras migración a fargate.
        // Fecha desactivación: 09/09/2026
        // Referencia: .kiro/specs/backend-url-switch
        // // Limpieza del override de backend URL. 08/07/2026
        // sessionStorage.removeItem('API_BASE_URL_OVERRIDE');
        localStorage.removeItem('token');
        localStorage.removeItem('usuario');
        localStorage.removeItem('id');
        localStorage.removeItem('emailuser');
        localStorage.removeItem('multi_supplier');
        localStorage.removeItem('expiratoken');
        localStorage.removeItem('usuarioPrivilegio');
        localStorage.removeItem('user_options');
        localStorage.removeItem('dataacc');
        localStorage.removeItem('quiensoy');
        localStorage.removeItem('job');
        localStorage.removeItem('foreign');
        this.router.navigate(['/loginven']);
        Swal.fire(
    'Terminó la sesión',
    'Correctamente',
    'info'
  );
      }
    });


  }

  // Logout para cliente Unita - redirige a /loginunita. 16/07/2025
  logoutunita() {

    Swal.fire({
      title: 'Cerrar Sesión?',
      text: `Se cerrará la sesión actual`,
      icon: 'question',
      showConfirmButton: true,
      showCancelButton: true,
    }). then ( resp => {
      if ( resp.value) {

        this.usuario = null;
        this.token = '';
        // Backend URL Switch — DESHABILITADO tras migración a fargate.
        // Fecha desactivación: 09/09/2026
        // Referencia: .kiro/specs/backend-url-switch
        // sessionStorage.removeItem('API_BASE_URL_OVERRIDE');
        localStorage.removeItem('token');
        localStorage.removeItem('usuario');
        localStorage.removeItem('id');
        localStorage.removeItem('emailuser');
        localStorage.removeItem('multi_supplier');
        localStorage.removeItem('expiratoken');
        localStorage.removeItem('usuarioPrivilegio');
        localStorage.removeItem('user_options');
        localStorage.removeItem('dataacc');
        localStorage.removeItem('quiensoy');
        localStorage.removeItem('job');
        localStorage.removeItem('foreign');
        this.router.navigate(['/loginunita']);
        Swal.fire(
    'Terminó la sesión',
    'Correctamente',
    'info'
  );
      }
    });


  }

  // Logout para módulo de Facturación Masiva - redirige a /loginfacturacion. 23/07/2026
  logoutfacturacion() {

    Swal.fire({
      title: 'Cerrar Sesión?',
      text: `Se cerrará la sesión actual`,
      icon: 'question',
      showConfirmButton: true,
      showCancelButton: true,
    }). then ( resp => {
      if ( resp.value) {

        this.usuario = null;
        this.token = '';
        // Backend URL Switch — DESHABILITADO tras migración a fargate.
        // Fecha desactivación: 09/09/2026
        // Referencia: .kiro/specs/backend-url-switch
        // sessionStorage.removeItem('API_BASE_URL_OVERRIDE');
        localStorage.removeItem('token');
        localStorage.removeItem('usuario');
        localStorage.removeItem('id');
        localStorage.removeItem('emailuser');
        localStorage.removeItem('multi_supplier');
        localStorage.removeItem('expiratoken');
        localStorage.removeItem('usuarioPrivilegio');
        localStorage.removeItem('user_options');
        localStorage.removeItem('dataacc');
        localStorage.removeItem('quiensoy');
        localStorage.removeItem('job');
        localStorage.removeItem('foreign');
        this.router.navigate(['/loginfacturacion']);
        Swal.fire(
    'Terminó la sesión',
    'Correctamente',
    'info'
  );
      }
    });


  }

  logoutsinboton() {
    this.usuario = null;
        this.token = '';
        // Backend URL Switch — DESHABILITADO tras migración a fargate.
        // Fecha desactivación: 09/09/2026
        // Referencia: .kiro/specs/backend-url-switch
        // // Limpieza del override de backend URL. 08/07/2026
        // sessionStorage.removeItem('API_BASE_URL_OVERRIDE');
        localStorage.removeItem('token');
        localStorage.removeItem('usuario');
        localStorage.removeItem('id');
        localStorage.removeItem('emailuser');
        localStorage.removeItem('multi_supplier');
        localStorage.removeItem('expiratoken');
        localStorage.removeItem('usuarioPrivilegio');
        localStorage.removeItem('user_options');
        localStorage.removeItem('dataacc');
        localStorage.removeItem('quiensoy');
        localStorage.removeItem('job');
        localStorage.removeItem('foreign');
        this.router.navigate(['/login']);
  }

  login( usuario: any, recordar: boolean = false ) {

    if ( recordar ) {
      localStorage.setItem('email', usuario.email );
    } else {
      localStorage.removeItem('email');
    }

    const url = `${environment.URL_SERVICIOS}/authenticate?auth[email]=${usuario.email}&auth[password]=${usuario.password}`;
    return this.http.get( url )
                .map( (resp: any) => {
                  this.guardarStoragelogin( resp.data.attributes.id,
                                            resp.data.token,
                                            resp.data.attributes.multi_supplier,
                                            resp.data.attributes.name,
                                            resp.data.attributes.email,
                                            resp.data.expires_at,
                                            resp.data.relations.user_options,
                                            resp.data.attributes.job,
                                            resp.data.foreign );
                                            this.options = [];
                                            this.getOptionsxUsuario(resp.data.attributes.id).subscribe(resp2 => {
                                              for (const j in resp2) {
                                                if (resp2.hasOwnProperty(j)) {
                                                  this.options.push(btoa(resp2[j].url));
                                                }
                                              }
                                              localStorage.setItem('dataacc', JSON.stringify(this.options));  
                                            })
                  return true;
                });


  }


  crearUsuario( usuario ) {

    const url = `${environment.URL_SERVICIOS}/users?auth[email]=${usuario.email}&auth[password]=${usuario.password}&auth[name]=${usuario.nombre}&auth[job]=${usuario.puesto}&auth[gender]=${usuario.genero}&auth[status]=${usuario.estatus}&auth[multi_supplier]=${usuario.multi_supplier}`;


    return this.http.post( url, null ).pipe(
              map( (resp: any) => {
                return resp;
              }));
  }

  createPublicDeed( params ) {

    const url = `${environment.URL_SERVICIOS}/public_deeds`;


    return this.http.post( url, params ).pipe(
              map( (resp: any) => {
                return resp;
              }));
  }

  deletePublicDeed( id ) {

    const url = `${environment.URL_SERVICIOS}/public_deeds/${id}`;


    return this.http.delete( url ).pipe(
              map( (resp: any) => {
                return resp;
              }));
  }

  patchPublicDeed(id, params) {

    const url = `${environment.URL_SERVICIOS}/public_deeds/${id}`;
    
    return this.http.patch( url, params ).pipe(
      map( (resp: any) => { return resp;
      } ));
    }

  getPublicDeedsByIdc(idc) {

    const url = `${environment.URL_SERVICIOS}/get_public_deeds_by_contributor_id/${idc}`;

    return this.http.get( url ).pipe(
      map( (resp: any) => {return resp;
    }));

    }

  getUsuarios() {

    const url = `${environment.URL_SERVICIOS}/users`;

    return this.http.get( url ).pipe(
    map( (resp: any) => {return this.crearArregloUsuarios(resp);
    }));

    }

    getUsuariosRc( totoken ) { //SUPER SOSPECHOSO
      const headers = new HttpHeaders({
      'Authentication': `Bearer ${totoken}`
      });

      const url = `${environment.URL_SERVICIOS}/users`;

      return this.http.get( url, {headers} ).pipe(
      map( (resp: any) => {return this.crearArregloUsuarios(resp);
      }));

      }
  crearArregloUsuarios( usuariosObj: any) {

    const usuarios: any[] = [];
    const resul: any[] = [];

    if ( usuariosObj === null ) { return []; }
    Object.keys ( usuariosObj ).forEach( key => {
      const usuario: any = usuariosObj[key];
      usuarios.push( usuario );
    });
    // tslint:disable-next-line: forin
    for (const prop in usuarios[0]) {
  //  console.log( usuarios[0][prop].attributes );
    resul.push( usuarios[0][prop].attributes );
    }

  //  console.log(resul);

    return resul;

}

getUsuario( id: string ) {

  const url = `${environment.URL_SERVICIOS}/users/${id}`;

  return this.http.get( url ).pipe(
    map ( (resp: any) => { return this.crearArregloUsuario(resp);
    } ));

}

getCreditLimit( id: string ) {

  const url = `${environment.URL_SERVICIOS}/reports/get_credit_line_per_user?user_id=${id}`;

  return this.http.get( url ).pipe(
    map ( (resp: any) => { return resp;
    } ));

}

crearArregloUsuario( usuariosObj: any) {

  const usuarios: any[] = [];
  const resul: any[] = [];
 // console.log(usuariosObj);
  if ( usuariosObj === null ) { return []; }
  Object.keys ( usuariosObj ).forEach( key => {
    const usuario: any = usuariosObj[key];
    usuarios.push( usuario );
  });
  // tslint:disable-next-line: forin
//  console.log( usuarios[0][prop].attributes );
  resul.push( usuariosObj.data.attributes );

 // console.log(resul);

  return resul;

}

getUsuarioOptions( id: string ) {

  const url = `${environment.URL_SERVICIOS}/users/${id}`;

  return this.http.get( url ).pipe(
    map ( (resp: any) => { return this.crearArregloUsuarioOptions(resp);
    } ));

}

crearArregloUsuarioOptions( usuariosObj: any) {

  const usuarios: any[] = [];
  const resul1: any[] = [];
  const resul2: any[] = [];
  if ( usuariosObj === null ) { return []; }

  // tslint:disable-next-line: forin
  for (const prop in usuariosObj.data.relations.options) {
  //    por el ID de la opcion
    //  resul.push( usuariosObj.data.relations.options[prop].attributes );
    resul1.push (usuariosObj.data.relations.options[prop].attributes);
    resul2.push (usuariosObj.data.relations.user_options[prop].attributes);

      }
 // console.log(resul2);
 // console.log(resul1);
  // tslint:disable-next-line: forin
  for (const prop in resul2) {

    const iduo = resul2[prop].option_id;

      // tslint:disable-next-line: forin
    for (const prap in resul1) {

      const ido = resul1[prap].id;

      if ( iduo === ido ) {

        resul2[prop].name = resul1[prap].name;

      }


      }

  }
 // console.log(resul2);
  return resul2;

}

/*actualizaUsuariodddd(usuario) {

const url = `${environment.URL_SERVICIOS}/users/${usuario.id}?auth[job]=${usuario.puesto}&auth[status]=${usuario.estatus}&auth[gender]=${usuario.genero}&auth[email]=${usuario.email}&auth[name]=${usuario.nombre}`;

return this.http.patch( url, null ).pipe(
  map( (resp: any) => { return resp;
  } ));
}*/

actualizaUsuario(usuario) {

  let params = [
    `auth[job]=${usuario.puesto}`,
    `auth[status]=${usuario.estatus}`,
    `auth[gender]=${usuario.genero}`,
    `auth[email]=${usuario.email}`,
    `auth[name]=${usuario.nombre}`
  ];

  // SOLO si viene definido (true o false) porque si no hace un desastre
  if (usuario.multi_supplier !== undefined && usuario.multi_supplier !== null) {
    params.push(`auth[multi_supplier]=${usuario.multi_supplier}`);
  }

  const url = `${environment.URL_SERVICIOS}/users/${usuario.id}?${params.join('&')}`;
  return this.http.patch(url, null).pipe(
    map((resp: any) => resp)
  );
}

patchUser(idu, params) {

const url = `${environment.URL_SERVICIOS}/users/${idu}`;

return this.http.patch( url, params ).pipe(
  map( (resp: any) => { return resp;
  } ));
}

actualizaUsuarioRc(idu, params) { //SUPER SOSPECHOSO

  const headers = new HttpHeaders({
    'Authentication': `Bearer ${params.token}`
  });

  const url = `${environment.URL_SERVICIOS}/users/${idu}?token=${params.token}&auth[password]=${params.password}`;

  return this.http.patch( url, null, {headers} ).pipe(
    map( (resp: any) => { return resp;
    } ));
  }

  actualizaUsuarioRcPc(idu, params) { //SUPER SOSPECHOSO

    const url = `${environment.URL_SERVICIOS}/users/${idu}?auth[password]=${params.password}`;

    return this.http.patch( url, null ).pipe(
      map( (resp: any) => { return resp;
      } ));
    }

borrarUsuario(usuario: any) {

  const url = `${environment.URL_SERVICIOS}/users/${usuario.id}`;

  return this.http.delete( url ).pipe(
    map( (resp: any) => { return resp;
     } ));

}

getResetPaswword(email) { //SUPER SOSPECHOSO
  const url = `${environment.URL_SERVICIOS}/reset_password?email=${email}`;
  return this.http.get( url ).pipe(
    map ( (resp: any) => { return (resp);
    } ));
}

getResetPasswordToken(rtoken) { //SUPER SOSPECHOSO
  const url = `${environment.URL_SERVICIOS}/get_reset_token?reset_password_token=${rtoken}`;
  return this.http.get( url ).pipe(
    map ( (resp: any) => { return this.crearArregloUsuario(resp);
    } ));
}

// LISTAS

getUserGender() {

  const url = `${environment.URL_SERVICIOS}/lists/domain/USER_GENDER`;



  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getUserStatus() {

  const url = `${environment.URL_SERVICIOS}/lists/domain/USER_STATUS`;



  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

crearArregloList( contribuObj: any) {

  const rr: any[] = [];
  const resul: any[] = [];

  if ( contribuObj === null ) { return []; }
  Object.keys ( contribuObj ).forEach( key => {
    const rol: any = contribuObj[key];
    rr.push( rol );
  });
  // tslint:disable-next-line: forin
  for ( const prop in rr[0] ) {

    resul.push( rr[0][prop].attributes.value );

  }

  return resul;

}

getOptionsxUsuario( id ) {

  const url = `${environment.URL_SERVICIOS}/reports/user_id/${id}/user_options`;

  /* return this.http.get( url ).pipe(
    map ( (resp: any) => { return resp;
    } )); */

    return this.http.get( url ).pipe(
    map ( (resp: any) => { return  resp;
    } ));

}

}
